module.exports = __webpack_public_path__ + "media/img/frontend_application/map/hongkong-83dcabd659ba5ca32a746953b8f4ab62.webp";